import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowDownNav = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.116 13.351a1.25 1.25 0 0 0 1.768 0l4.858-4.858a1.05 1.05 0 1 0-1.485-1.485L10 11.265 5.742 7.008a1.05 1.05 0 1 0-1.484 1.485zm6.414-5.07-4.858 4.858L15.53 8.28Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowDownNav;
